import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'
import { formatInstrumentLabel } from '../../utils/formatInstrument'

export const getAssetsLoadingState = (state: RootState): RootState['assets']['loading'] => state.assets.loading

export const assetsLoading = createSelector(
  getAssetsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getAssetsData = (state: RootState): RootState['assets']['data'] => state.assets.data

export const getInstrumentsForCreateAssetLoadingState = (
  state: RootState,
): RootState['assets']['instrumentsForCreateAsset']['loading'] => state.assets.instrumentsForCreateAsset.loading

export const getInstrumentsForCreateAssetLoading = createSelector(
  getInstrumentsForCreateAssetLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getInstrumentsForCreateAssetData = (
  state: RootState,
): RootState['assets']['instrumentsForCreateAsset']['data'] => state.assets.instrumentsForCreateAsset.data
export const getInstrumentsForCreateAssetEnum = createSelector(getInstrumentsForCreateAssetData, (instruments) =>
  instruments.map((instrument) => ({
    value: instrument.instrument,
    label: formatInstrumentLabel(instrument.underlier),
  })),
)
export const createPairModal = (state: RootState): RootState['assets']['createAssetModal'] =>
  state.assets.createAssetModal

export const updatePairModal = (state: RootState): RootState['assets']['updateAssetModal'] =>
  state.assets.updateAssetModal
